import { Box, Flex, keyframes } from '@chakra-ui/react';
import Image from 'next/image';

import { logos } from '@utils/company-logos';

const scroll = keyframes`
  0% { transform: translateX(0%); }
  100% { transform: translateX(-50%); }
`;

export const CompanyLogoCarousal = () => (
    <Box
        overflow="hidden"
        position="relative"
        bg="#FAFAFF"
        py="50px"
        px={{ base: 4, md: 10 }}
        mx={{ base: 0, md: -10, lg: -20 }}
    >
        <Box
            position="absolute"
            left="0"
            top="0"
            bottom="0"
            width="90px"
            bg="#FAFAFF"
            zIndex="1"
            display={{ base: 'none', lg: 'block' }}
        />
        <Box
            position="absolute"
            right="0"
            top="0"
            bottom="0"
            width="90px"
            bg="#FAFAFF"
            zIndex="1"
            display={{ base: 'none', lg: 'block' }}
        />

        <Box
            pl="150px"
            pr="150px"
            whiteSpace="nowrap"
            display="inline-block"
            animation={`${scroll} 30s linear infinite`}
            width="fit-content"
        >
            <Flex as="span" gap={{ base: 8, md: 10 }}>
                {[...logos, ...logos].map((src, i) => (
                    <Box
                        key={i}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        minW="80px"
                        height="90px"
                    >
                        <Image
                            src={src}
                            alt={`logo-${i}`}
                            width={80}
                            height={90}
                            style={{ objectFit: 'contain' }}
                        />
                    </Box>
                ))}
            </Flex>
        </Box>
    </Box>
);
